import { Consumption } from './app.interfaces';

export type XY = { x: number | string | Date; y: number | null };
export type Kind = 'nominations' | 'real';

export type Series = {
  id: string;
  label: string;
  kind: Kind;
  data: XY[];
  color?: string;
};

// Represents a grouped consumption row when multiple CUPS with same identifier are selected
export interface GroupedConsumption {
  isGrouped: true;
  date: Date;
  identifier: string;
  alias: string;
  consumptions: Consumption[]; // All consumptions for this identifier on this date
  totalNomination: number | null;
  totalDifference: number | null; // Used instead of difference for grouped rows
  enagas: number | null;
  difference: number | null;
}

export type ConsumptionTableRow = Consumption | GroupedConsumption;

// Type guard to check if a row is grouped
export const isGroupedConsumption = (row: ConsumptionTableRow): row is GroupedConsumption =>
  'isGrouped' in row && row.isGrouped === true;

export interface ConsumptionChartResponse {
  consumptions: Series[];
  averages: { nomination: number; enagas: number };
}

export interface ConsumptionTableResponse {
  consumptions: Consumption[];
  meta: {
    averages: { nomination: number; enagas: number };
    months: { month: number }[];
  };
}
